export class ModalInscription extends HTMLDivElement {

    connectedCallback() {
        this.addEventListener('show.bs.modal', (event: Event) => {
            const btn = (event as CustomEvent & { relatedTarget: HTMLElement | null }).relatedTarget;
            if (!btn) return;

            const formationId = btn.dataset.formationId ?? '';
            const sessionId   = btn.dataset.sessionId   ?? '';
            const intitule    = btn.dataset.formationIntitule ?? '';
            const libelle     = btn.dataset.sessionLibelle    ?? '';
            const siteNom     = btn.dataset.siteNom           ?? '';

            const el = (sel: string) => this.querySelector(sel);

            const intituleEl = el('.js-modal-formation-intitule');
            const libelleEl  = el('.js-modal-session-libelle');
            const siteEl     = el('.js-modal-site-nom');
            const linkEntr   = el('.js-modal-url-entreprise')  as HTMLAnchorElement | null;
            const linkPart   = el('.js-modal-url-particulier') as HTMLAnchorElement | null;

            if (intituleEl) intituleEl.textContent = intitule;
            if (libelleEl)  libelleEl.textContent  = libelle;
            if (siteEl)     siteEl.textContent      = siteNom;

            if (formationId && sessionId) {
                const base = `/formation/${formationId}/inscription/${sessionId}/`;
                if (linkEntr) linkEntr.href = `${base}entreprise/1`;
                if (linkPart) linkPart.href = `${base}particulier/1`;
            }
        });
    }
}
